import React from 'react';
import './coach.css';
import { useDispatch } from "react-redux";
import { coachFormAction, photoFileAction } from "../../redux/rootReducer";
import { removeCoachSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";
import user_image from '../../assets/i/user.svg';

const Coach = ({ data }) => {
    const dispatch = useDispatch();

    return (
        <div className="coach">
            <div className="controls">
                <i className="control control--edit"
                    onClick={ () => {
                        dispatch(coachFormAction({
                            open: true,
                            id: data.id,
                            image: data.photo,
                            name: data.name,
                            description: data.description,
                            phone: data.phone,
                            email: data.email,
                            hide: data.hide,
                            establishments: data.establishment,
                            links: data.links
                        }));
                        dispatch(photoFileAction(null));
                    } }
                />
                <i className="control control--remove"
                   onClick={ () => {

                       if (window.confirm('Вы действительно хотите удалить тренера?')) {
                           dispatch(removeCoachSagaAction({
                               coach_id: data.id
                           }));
                       }
                   } }
                />
            </div>
            <div className="coach__image" style={{
                backgroundImage: `url(${ data.photo ? site + data.photo : user_image })`,
                backgroundSize: data.photo ? 'cover' : false,
                opacity: data.photo ? 1 : .48
            }}/>
            <div className="coach__name">{ data.name }</div>
            { data.phone ? <div className="coach__phone">{ data.phone }</div> : false }
            { data.email ? <div className="coach__email">{ data.email }</div> : false }
            { data.description ? <div className="coach__description">{ data.description }</div> : false }
            {
                data.links.length
                    ?
                    <div className="coach__links">
                        {
                            data.links.map((elem, index) => {
                                let style = {};

                                if (elem.ico) {
                                    style = { backgroundImage: `url(${ elem.ico })` };
                                }

                                return (
                                    <div key={ index } className="coach__link">
                                        <div className="coach__link-ico"
                                             style={ style }
                                        />
                                        <div className="coach__link-link">{ elem.link }</div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    : false
            }
        </div>
    );
};

export default Coach;